module.exports = __webpack_public_path__ + "img/dialog-bg.e3ac14a8.png";